// グループコンテキスト Resolver
// URL の projectId に紐づくグループを GroupsStore に選択状態として設定する
import { inject } from '@angular/core';
import { type ActivatedRouteSnapshot, type ResolveFn } from '@angular/router';

import { GroupsStore } from '../groups.store';

/**
 * groupContextResolver
 * projects/:projectId ルートで projectContextResolver と並列実行される。
 * groupsStore.selectGroupForProject(projectId) を呼び出して選択グループを確定させる。
 * projectsStore は参照しない（features 間越境を避けるため）。
 */
export const groupContextResolver: ResolveFn<boolean> = async (
  route: ActivatedRouteSnapshot,
) => {
  const groupsStore = inject(GroupsStore);

  const projectId = route.params['projectId'] as string | undefined;
  if (!projectId) return true;

  await groupsStore.selectGroupForProject(projectId);
  return true;
};
